import React, { useRef, useEffect } from "react";
import { Box } from "@mui/material";


const BentoBoxGrid = ({ children, gap = 2, column = 12, ROW_HEIGHT = 5.5 }) => {
  const gridRef = useRef(null);
  const recalcRowSpans = () => {
    const grid = gridRef.current;
    if (!grid) return;

    const items = grid.querySelectorAll(".bento-item-inner");
    items.forEach((item) => {
      const wrapper = item.parentElement; // the BentoItem Box
      wrapper.style.gridRow = "auto"; // reset first
      const height = item.getBoundingClientRect().height;
      const rowSpan = Math.ceil((height + gap * 8) / (ROW_HEIGHT + gap * 8));
      wrapper.style.gridRow = `span ${rowSpan}`;
    });
  };

  useEffect(() => {
    recalcRowSpans();

    const observer = new ResizeObserver(() => {
      window.requestAnimationFrame(recalcRowSpans); // rAF prevents the loop error
    });

    const items = gridRef.current?.querySelectorAll(".bento-item-inner");
    items?.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, [children]); // re-run when children change

  return (
    <Box
      ref={gridRef}
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${column}, 1fr)`,
        gridAutoRows: `${ROW_HEIGHT}px`, // ← fixed small unit
        gap: `${gap * 8}px`,
        alignItems: "start",
        gridAutoFlow: "dense", // ← fills gaps automatically
      }}>
      {children}
    </Box>
  );
};

export default BentoBoxGrid;
